export function normalizeFloor(vm) {
  const { floor } = vm;
  const row = floor.$row.split('-')[1];
  const style = floor.$style.split('-')[1];
  const isWaterfall = row === 'two' && floor.heightMode === 2;

  function normalizeCorner() {
    const type = floor.cornerType;
    if (type) {
      const corner = {};
      const klass = ['corner', type, floor.cornerImagePosition || 'LEFT_TOP'];
      if (['CUSTOM', 'PHOTO_FRAME'].includes(type)) {
        const image = floor.cornerImageImage;
        corner.url = image && image.imageUrl;
        corner.isPhotoFrame = corner.url && type === 'PHOTO_FRAME';
      } else {
        const names = {
          NEW: '新品',
          HOT_SALE: '热卖'
        };
        corner.name = names[type];
      }
      corner.klass = klass.join(' ');
      return corner;
    }
  }
  function normalizeLabel() {
    const label = Object.assign(
      {
        btnColor: '#F8D541',
        fontColor: '#333333',
        priceLabel: ''
      },
      floor.goodsStyle1
    );
    if (label.priceLabel) {
      return {
        bgColor: label.btnColor,
        color: label.fontColor,
        name: label.priceLabel
      };
    }
  }
  function normalizeButton() {
    const ds = floor.displayContentStyle;
    const res = {
      bgColor: floor.colorBgBox,
      color: floor.colorFont,
      name: floor.receiveText
    };
    if (ds) {
      res.linkType = ds.jump
    }
    if (row === 'one' && style === 'two') {
      res.bgColor = 'linear-gradient(90deg, #FF8200 0%, #FF1414 100%)';
      res.color = '#ffffff';
      res.name = '去抢购';
    }
    if (res.bgColor && res.color && res.name) {
      return res;
    }
  }
  function normalizeShopButton() {
    const display = floor.$display;
    if (!(display.buyButton || display.shopCartButton)) return;
  
    const ds = floor.displayContentStyle || {};
    const style = ds.buyStyle || ds.cartStyle || 1;
    const styles = {
      1: 'one',
      2: 'two',
      3: 'three'
    };
    const _icons = {
      buy: {
        1: [
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691056353859612626070089349.png',
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691056995349612690219167063.png'
        ],
        2: [
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691080536977026163232163025.png',
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691080689543293480663470127.png'
        ],
        3: [
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691080872749613336024023499.png',
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691080994377026208008318400.png'
        ]
      },
      cart: {
        1: [
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691091020269616092634013953.png',
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691091170057026075659344458.png'
        ],
        2: [
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691091361577026094810646027.png',
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691091499489614398698021161.png'
        ],
        3: [
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691091622387027270809621135.png',
          'https://img.chinabeego.com/uploadfile/2022/11/22/16691091754117026134065280450.png'
        ]
      }
    };
    const icons = display.buyButton ? _icons.buy : _icons.cart;
    const [image, emptyImage] = icons[style];
    return {
      style: styles[style],
      image,
      emptyImage
    };
  }
  function normalizeShow(corner) {
    const isPhotoFrame = corner && corner.isPhotoFrame; // 是否相框图
    const display = floor.$display;
    const show = {
      store: display.storeName,
      image: {},
      content: {
        label: true,
        price: true,
        estimateTag: true,
        markingPrice: true,
        discount: true,
        tag: true
      }
    };
    switch (row) {
      case 'one':
        switch (style) {
          case 'one':
            show.content.price = true;
            show.content.logoName = true;
            show.content.label = false;
            show.content.label2 = true;
            show.content.estimateTag = false;
            show.content.discount = display.markingPrice;
            show.content.markingPrice = display.markingPrice;
            show.content.tag = display.goodsDiscount;
            show.content.monthSales = display.monthSales;
            break;
          case 'two':
            show.store = true;
            show.content.label = display.fontLabel;
            show.content.marketLabel = display.marketLabel;
            show.content.discount = display.markingPrice;
            show.content.monthSales = display.monthSales;
            show.content.markingPrice = display.markingPrice;
            show.content.subTitle = true;
            show.content.estimateTag = true;
            show.content.btn = true;
            break;
        }
        break;
      case 'two':
        const t1 = !isWaterfall && !isPhotoFrame;
        const t2 = isWaterfall;
        switch (style) {
          case 'one':
            show.image.tag = t1 && display.goodsDiscount;
            show.content.tag = t2 && display.goodsDiscount;
            show.content.markingPrice = display.markingPrice;
            show.content.discount = display.markingPrice;
            break;
          case 'two':
            show.image.tag = t1;
            show.content.tag = t2;
            break;  
          case 'three':
            show.image.tag = t1 && display.goodsDiscount;
            show.content.tag = t2 && display.goodsDiscount;
            show.content.markingPrice = display.markingPrice;
            show.content.discount = display.markingPrice;
            break;
          case 'four':
            show.image.tag = false;
            show.content.tag = true;
            show.content.markingPrice = false;
            show.content.discount = false;
            show.content.btn = true;
            break;
          case 'five':
            show.image.tag = false;
            show.content.tag = true;
            show.content.discount = display.markingPrice;
            show.content.markingPrice = display.markingPrice;
            break;
        }
        break;
      case 'three':
        show.image.tag = !isPhotoFrame;
        show.content.tag = false;
        switch (style) {
          case 'two':
          case 'three':
            show.content.label = false;
            break;
        }
        break;
      case 'four':
      case 'multiple':
        show.content.label = false;
        show.content.tag = false;
        show.content.discount = false;
        show.content.estimateTag = false;
        break;
    }
    return show;
  }
  function normalizeClass() {
    const classes = [
      'container',
      floor.$row,
      floor.$style,
      isWaterfall ? 'waterfall-flow' : 'fixed-height',
      vm.show.store ? 'show-store' : ''
    ];
    if (floor.fontStyle === 2) {
      classes.push('font-bold');
    }
    return classes.join(' ');
  }
  vm.isWaterfall = isWaterfall;
  vm.corner = normalizeCorner();
  vm.label = normalizeLabel();
  vm.button = normalizeButton();
  vm.shopButton = normalizeShopButton();
  vm.show = normalizeShow(vm.corner);
  vm.classes = normalizeClass();
}

/**
 * 获取文案标签宽度
 * 设置标题首行缩进
 */
export function setTextIndent(vm) {
  if (vm.label) {
    vm.$nextTick(() => {
      const name = vm.$el.querySelectorAll('.goods-name')[0];
      const label = name && name.querySelector('.label');
      vm.styleVar = label ? `--text-indent: ${label.offsetWidth}px` : '';
    });
  } else {
    vm.styleVar = '';
  }
}
